var React = require('react');

function Download (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 16L16 11H13V4H11V11H8L12 16Z","fill":"#7088A1","key":0}),React.createElement("path",{"d":"M20 18H4V11H2V18C2 19.103 2.897 20 4 20H20C21.103 20 22 19.103 22 18V11H20V18Z","fill":"#7088A1","key":1})]);
}

Download.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Download;

Download.default = Download;
